import { Button, Divider, Dropdown, Menu } from "antd";
import { IArrowDropdownProps } from "../../utils/interfaces/interviewKit";
import { useDispatch} from 'react-redux'
import { useEffect, useRef, useState } from "react";

const DropdownWithButton: React.FC<IArrowDropdownProps & { isLoadingBtn: boolean, isDisabledBtn: boolean }> = ({
    list,
    imageSrc,
    selectedTemplate,
    setSelectedTemplate,
    withDivider,
    className,
    imgClassName,
    menuClassName,
    isLoadingBtn,
    isDisabledBtn
}) => {
    const dispatch = useDispatch()
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const triggerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        function handleClickOutside(e: MouseEvent) {
            const target = e.target as HTMLElement;
            const clickedInsideTrigger = triggerRef.current?.contains(target);
            const clickedInsideDropdown = target.closest(".ant-dropdown"); 
            if (!clickedInsideTrigger && !clickedInsideDropdown) {
                setDropdownOpen(false);
            }
        }

        if (dropdownOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [dropdownOpen, dispatch]);
    
    const listMenu = (
        <Menu className={`xs:w-72 max-w-96 max-h-52 absolute !rounded-xl !px-2 !py-1 left-5 md:left-0 overflow-y-auto ${menuClassName ? menuClassName : ''}`}>
            {list.length > 0 ? (
                list?.map((item: any, index: number) => (
                    <div key={index}>
                        {index === list.length - 1 && withDivider && (
                            <Divider className="my-1 border-t border-gray-300" />
                        )}
                        <Menu.Item
                            key={item?.key}
                            disabled={item?.disabled}
                            onClick={(e) => {
                                e.domEvent.stopPropagation();
                                dispatch(setSelectedTemplate(item));
                                setDropdownOpen(false);
                            }}
                            className={`w-full h-10 rounded-1.5 !text-4 font-normal flex !bg-white !my-1 !p-0`}
                        >
                            <div className="flex items-center gap-2">
                                {
                                    <div
                                        className={`px-4 py-2 w-full text-base rounded hover:!bg-[#EEF2FF]
                      } ${selectedTemplate?.key === item?.key ? 'bg-indigo-50' : ''} capitalize`}
                                    >
                                        {item?.label}
                                    </div>
                                }
                            </div>
                        </Menu.Item>
                    </div>
                ))
            ) : (
                <Menu.Item>No items available</Menu.Item>
            )}
        </Menu>
    );

    return (
        <div className="flex w-full" ref={triggerRef}>
            <Button
                loading={isLoadingBtn}
                disabled={isDisabledBtn}
                className='btn-primary-light !rounded-l-md !rounded-br-none !rounded-tr-none !border-none !pr-2 !bg-indigo-50 border-indigo-50 !text-indigo-700' onClick={(e) => { setDropdownOpen(!dropdownOpen) }}>
                Use Pre-saved Template
            </Button>
            <Dropdown
                className={`relative cursor-pointer ${className ?? ""}`}
                rootClassName="xs:!relative xs:!left-0"
                open={dropdownOpen}
                trigger={["click"]}
                dropdownRender={() =>
                    listMenu
                }>
                <div
                    onClick={(e) => {
                        e.stopPropagation();
                        setDropdownOpen(!dropdownOpen);
                    }}
                    className="cursor-pointer"
                >
                    <img src={imageSrc} alt="Dropdown Icon" className={`w-4 h-4 mt-1 ${imgClassName ?? ''}`} />
                </div>
            </Dropdown>
        </div>
    );
};

export default DropdownWithButton;